<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <el-form-item label="选择日期">
            <el-input v-model="formInline.user" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="选择餐时">
            <el-select v-model="formInline.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择菜品">
            <el-select v-model="formInline.region" placeholder="请选择">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="min-width: 150px;">
            <el-button
              type="primary"
              style="background: #1890ff;"
              @click="onSubmit"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="onSubmit"
              >重置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="菜品名" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="餐时" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单价" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费人次" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="人均消费额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="center_div">
      <div>菜品三个月销售情况</div>
      <div class="center_div_border"></div>
    </div>
    <div class="center_div">
      <div>菜品分区域销售情况</div>
      <div class="center_div_border"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      tableData: []
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
</style>
